<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.rolepermission') }} > {{ rolePermissionSingle.title }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right">
        <div
          v-if="!loading"
          class="action">
          <BaseActionDropdown
            :icon="`fas fa-cog`"
            :text="$t('button.options')"
            :items="[
              {
                icon: 'fas fa-trash',
                iconClassName: 'text-danger',
                text: $t('button.delete'),
                textClassName: 'text-danger',
                value: 'delete',
              }
            ]"
            @onSelect="handleSelectOption"
          />
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <RolePermissionForm
        :state="rolePermissionSingle"
        :appRolePermissions="appRolePermissions"
        :isSubmitted="isSubmitted"
        :disabled="disabled"
        :form.sync="form"
        @onSubmit="handleSubmit"
      />

      <baseConfirmDeleteModal
        :show="modal.show"
        :loading="modal.loading"
        @onClose="handleCloseModal"
        @onCancel="handleCancleModal"
        @onSubmit="handleSumitModal"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  mixins: [discardFormMixin],

  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      query: {
        id: this.$route.query.id,
        title: this.$route.query.title,
      },
      modal: {
        show: false,
        loading: false,
      },
      form: null,
    }
  },

  computed: {
    ...mapState('appPermission', {
      appRolePermissions: 'permissionList',
    }),
    ...mapState('rolePermission', {
      rolePermissionSingle: 'rolePermissionSingle',
    }),
    ...mapGetters({
      sidebar: 'getSidebar',
    }),
  },

  created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.settings.title'),
      current: {
        app_name: 'settings',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 3, [{
      'name': this.query.title,
      'router': {
        'name': 'SettingsRolePermissionEdit',
        'query': {
          id: this.query.id,
          title: this.query.title,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 3,
      submenuAtIdx: 2,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('appPermission', {
      getAppPermissionList: 'getAppPermissionList',
    }),
    ...mapActions('rolePermission', {
      getRolePermissionSingle: 'getRolePermissionSingle',
      updateRolePermission: 'updateRolePermission',
      deleteRolePermission: 'deleteRolePermission',
    }),
    async fetchData () {
      this.loading = true
      await Promise.all([
        this.getAppPermissionList(),
        this.getRolePermissionSingle(this.query.id),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    async handleSubmit (input = {}) {
      this.isSubmitted = true
      this.disabled = true
      const response = await this.updateRolePermission({
        id: this.query.id,
        data: {
          title: input.title,
          permissions: input.permissions,
        },
      })
      if (response.success) {
        this.isSubmitted = false
        this.disabled = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: input.title }),
          color: 'success',
          icon: 'cloud',
        })
        this.fetchData()
      }
    },
    handleSelectOption (value) {
      if (value === 'delete') {
        this.onOpenModal()
      }
    },
    onOpenModal () {
      this.modal.show = true
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal () {
      this.modal.loading = true
      const response = await this.deleteRolePermission(this.query.id)
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.rolePermissionSingle.title }),
          color: 'danger',
          icon: 'delete',
        })
        this.modal.loading = false
        this.modal.show = false
        this.$router.push({ name: 'SettingsRolePermissionList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/settings/rolepermission/Edit.vue